<template>
    <div>
        <v-row>
            <v-col>
                <h4 class="text-h4">Export Transcations</h4>
                <p class="text-subtitle">Export to excel</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-form ref="form">

            <v-row>
                <v-col cols="12" md="3">
                    <v-text-field
                        outlined
                        dense
                        :rules="[isRequired, isNumeric]"
                        hide-details="auto"
                        v-model="form.account_from"
                        label="Account From"></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                    <v-text-field
                        outlined
                        dense
                        :rules="[isRequired, isNumeric]"
                        hide-details="auto"
                        v-model="form.account_to"
                        label="Account To"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <DatePicker
                        dense
                        outlined   
                        label="Date From"
                        :rules="[isRequired]"
                        v-model="form.date_from" 
                    />
                </v-col>
                <v-col cols="12" md="3">
                    <DatePicker
                        label="Date To"
                        outlined
                        dense
                        :rules="[isRequired]"
                        v-model="form.date_to"
                    />
                </v-col>
            </v-row>
        </v-form>
        <v-row no-gutters v-show="loading">
            <v-col cols="12" md="6">
                <v-alert dense text color="warning" dark icon="mdi-alert">
                    <span class="font-weight-bold">{{formatNumber(loaded / 1024)}} KBs Downloaded. </span>
                    Please wait. This might take few mintues.
                </v-alert>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12" md="3">
                <v-btn @click="getAsync" block color="primary" :loading="loading">
                    <v-icon>mdi-file-excel</v-icon>
                    export
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import DatePicker from "./../../components/common/DatePicker.vue";
import ExportApi from "../../services/ledger/export";
import { isRequired, isNumeric } from './../../utils/validations';
import moment from 'moment'
import { formatNumber } from 'accounting';
export default {
    components: {
        DatePicker
    },
    data: function () {
        return {
            form: {
                date_from: moment().startOf("month").format("YYYY-MM-DD"),
                date_to: moment().endOf("month").format("YYYY-MM-DD"),
                account_from: null,
                account_to: null
            },
            loading: false,
            loaded: 0
        }
    },
    methods: {
        isRequired, isNumeric,
        formatNumber(n) {
            return formatNumber(n, 2)
        },
        getAsync() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            this.loaded = 0;
            const onDownloadProgress = (progressEvent => {
                this.loaded = progressEvent.loaded
            })
            ExportApi.exportTransactions(this.form, onDownloadProgress).then((response) => {
                const blob = new Blob([response.data], { type: 'application/csv' })
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = `exported_transactions_${this.form.date_from}_${this.form.date_to}_${this.form.account_from}_${this.form.account_to}.csv`
                link.click()
                URL.revokeObjectURL(link.href)
            }).finally(() => {
                this.loading = false;
            })
        }
    }
}
</script>
